<template>
<div> 
  <main class="container-fluid"> 
    <div class="row">
      <div class='col-4 px-3 py-3 d-none d-md-flex'>
      </div> 
      <div class='col d-column mt-2'>   
        <h1 class="title pt-2 mb-0" v-text="$ml.get('jobBoard')"></h1>
        <h1 class="title" v-if="['owner','administrator'].includes($store.getters['getUser'].role)" ><span v-text="$ml.get('weLeaveThisPanel')" class="pb-2"></span></h1> 
        <h1 class="title" v-else><span v-text="$ml.get('findSecurityJobsOnOurDashboard')" class="pb-2"></span></h1> 
      </div> 
    </div>
    <section class="row">
      <div class='col-4 px-3 py-3 d-none d-md-flex'></div>
      <div class="col-24 col-md-5 pr-md-3 py-md-3 px-3 px-md-0">

        <h6 class="mb-2">{{$ml.get('jobTitle')}}</h6>
        <div class="input-group mb-3">
          <input
            class="form-control filterInput"
            v-model="titleSearch"
            :placeholder="$ml.get('search')"
            aria-label="Search"
            style="border-right: none"
          />
          <div class="input-group-append">
            <div class="input-group-text" style="background-color: #fff" >
              <svg width="20" height="20" class="mt-1">
                <image xlink:href="../../assets/icons/search_s.svg" width="18" height="18" />
              </svg>
            </div>
          </div>
        </div> 
  
        <h6 class="py-2 mb-0" v-text="$ml.get('location')"></h6>
        <div class="input-group">
          <input
            class="form-control filterInput"
            v-model="locationSearch"
            :placeholder="$ml.get('search')"
            aria-label="Search"
            style="border-right: none"
          />
          <div class="input-group-append">
            <div class="input-group-text" style="background-color: #fff" >
              <svg width="20" height="20" class="mt-1">
                <image xlink:href="../../assets/icons/search_s.svg" width="18" height="18" />
              </svg>
            </div>
          </div>
        </div> 
       
        <aside class='mt-4 pt-4'>
          <ul class="none-p-m">   
            <li class='pb-2 m-0'>
              <a>{{$ml.get('typeOfContract')}}</a>
              <ul class='none-p-m pt-2 pb-3 pointer' @click="menuItem ='jobs'">
                <li :class="!checkContract_type ? 'active py-1' :'py-1'">
                  <i><img src="../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
                  <a @click="checkContract_type = ''" v-text="$ml.get('all')"></a>
                </li>
                <li v-for="(item, index) in arrayContract_type" :key="index" :class="checkContract_type == item ? 'active py-1' :'py-1'">
                  <i><img src="../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
                  <a @click="checkContract_type = item " >{{nameLang(item)}}</a>
                </li> 
              </ul>
            </li>
          </ul>

          <ul class="none-p-m">   
            <li class='pb-2 m-0'>
              <a>{{$ml.get('workModel')}} </a>
              <ul class='none-p-m pt-2 pb-3 pointer' @click="menuItem ='jobs'">
                <li :class="!checkWork_model ? 'active py-1' :'py-1'">
                  <i><img src="../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
                  <a @click="checkWork_model = ''" v-text="$ml.get('all')"></a>
                </li>
                <li v-for="(item, index) in arrayWork_model" :key="index" :class="checkWork_model == item ? 'active py-1' :'py-1'">
                  <i><img src="../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
                  <a @click="checkWork_model = item" >{{nameLang(item)}}</a>
                </li> 
              </ul>
            </li>
          </ul>

          <ul class="none-p-m">   
            <li class='pb-2 m-0'>
              <a>{{$ml.get('workSchedule')}}</a>
              <ul class='none-p-m pt-2 pb-3 pointer' @click="menuItem ='jobs'">
                <li :class="!checkWork_schedule ? 'active py-1' :'py-1'">
                  <i><img src="../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
                  <a @click="checkWork_schedule = ''" v-text="$ml.get('all')"></a>
                </li>
                <li v-for="(item, index) in arrayWork_schedule" :key="index" :class="checkWork_schedule == item ? 'active py-1' :'py-1'">
                  <i><img src="../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
                  <a @click="checkWork_schedule = item " >{{nameLang(item)}}</a>
                </li> 
              </ul>
            </li>
          </ul>
        </aside>

 
      </div>
      <div class='col-24 col-md-11 px-md-3 py-md-3 pt-3 pt-md-0 px-3 px-md-0 mb-md-5'>
        <div class='col d-column'> 
        <div>
          <b-nav tabs>
            <b-nav-item :active="menuItem === 'jobs'" @click="menuItem = 'jobs', changeJobs()" >
              {{$ml.get('registeredVacancies')}}
            </b-nav-item>
            <b-nav-item v-if="['owner','administrator'].includes($store.getters['getUser'].role)" 
              :active="menuItem === 'createJobs'" 
              @click="menuItem = 'createJobs'">
              {{$ml.get('registration')}}
            </b-nav-item>
          </b-nav>
        </div>
         
          <!-- List Jobs -->
          <div v-if="menuItem === 'jobs'" class="card mb-4 position-relative">
            <div class="card-body mb-0 pb-0">  
              <div class="loading d-flex">

                <div v-if="loadingJobs" class="c-loader mt-3 mb-4"></div>
                  <h6 v-else v-show="!listJobs.length" class="pt-3 pb-4">
                    {{$ml.get('noJobsFound')}}
                  </h6>
                </div>
                <svg v-b-tooltip.hover 
                v-show="listJobs.length"
                :title="$ml.get('seeOriginalText')" 
                @click="showOriginalDescription = !showOriginalDescription"
                width="25" 
                height="25" 
                class="mx-2 icon-description">
                    <image
                      xlink:href="../../assets/svg/aa.svg"
                      width="25"
                      height="25"
                    />
                </svg>
              <div v-for="(item, index) in listJobs" :key="index"> 

                <div class="accordion" role="tablist">  
                  <div block v-b-toggle="'accJob-' + index" variant="info" class="row collapsed d-flex justify-content-center align-items-center"> 
                    <div style="width: 72px">
                      <object width="62" height="62" class="rounded-circle img-lg mr-3" :data="item.avatar" type="image/png" >
                        <img width="62" height="62" class="rounded-circle img-lg mr-3" src="../../assets/images/default.png" alt="Avatar" />
                      </object>
                    </div> 
                    
                    <div class="col pb-2">
                      <div class="row">
                        <h4>{{item.title}}</h4>
                      </div>
                      <div class="row">
                        <!-- Modelo de trabalho -->  
                        <h5 v-if="item.work_model != 'others'" class="mr-2"><b-badge>{{nameLang(item.work_model)}}</b-badge></h5>  
                        <!-- Contract Type -->  
                        <h5 v-if="item.contract_type != 'others'" class="mr-2"><b-badge>{{nameLang(item.contract_type)}}</b-badge></h5>   
                        <!-- Work schedule -->  
                        <h5 v-if="item.work_schedule != 'others'" class="mr-2"><b-badge>{{nameLang(item.work_schedule)}}</b-badge></h5>  
                      </div> 
                    </div>
  
                    <span class="when-opened">
                      <img src="../../assets/icons/angle-right_black.svg" class="ico-16 angle-right" />
                    </span>
                    <span class="when-closed">
                      <img src="../../assets/icons/angle-right_black.svg" class="ico-16" />
                    </span>  
                  </div>

                  <b-collapse :id="'accJob-'+ index" visible accordion="my-accordion" role="tabpanel" >
                    <div class="col-22">
                      <!-- Description -->
                      <div class="row mb-2"> 
                        <div v-show="!showOriginalDescription" class="text-markdown"  
                          v-html="$utils.convertMarkedOld(item.translated_description)" >
                        </div>  
                        <div v-show="showOriginalDescription" class="text-markdown"  
                          v-html="$utils.convertMarkedOld(item.description)" >
                        </div>   
                      </div>

                      <!-- City State-->
                      <h5>{{item.city}} <label v-if="item.state"> - </label> {{item.state}}</h5 > 
                      
                      <!-- Link -->
                      <div class="row mb-4">
                        <div class="col pr-1" @click="linkExternal"> 
                          <a target="_blank"
                            rel="noopener noreferrer" 
                            :href="item.url">{{item.url}}</a> 
                        </div>
                      </div>  

                      <button @click="removeJobs(item)" 
                        v-if="['owner','administrator'].includes($store.getters['getUser'].role)"
                        class="btn btn-outline-extra m-0 mb-3"> 
                        <span v-text="$ml.get('remove')"></span>
                      </button> 
                    
                    </div>
                  </b-collapse> 
 
                </div> 
                <hr v-if="index != listJobs.length - 1" class="mt-0 pt-0"> 
              </div>  

              <div v-show="totalPages > 10 && listJobs.length" class="p-3">
                <b-pagination v-model="pageActive" :total-rows="totalPages" :per-page="pageSize"
                  :prev-text="$ml.get('previous')" :next-text="$ml.get('next')" align="right">
                </b-pagination>
              </div> 
            </div> 
          </div>

          <!-- Create Jobs -->
          <div v-if="menuItem === 'createJobs'" class="card mb-4"> 
            <div class="card-body">
              <form v-on:submit.prevent="">
                 
                  <!-- title -->
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group">
                        <label class="text-muted" v-text="$ml.get('jobTitle')"></label >
                        <input
                          type="text"
                          class="form-control"
                          :placeholder="$ml.get('securityAnalyst')"
                          v-model="title"
                          maxlength="200"
                        /> 
                      </div> 
                      <transition name="fade"> 
                        <label v-if="submitError && !$v.title.required"
                            class="lblError" 
                            v-text="$ml.get('requiredField')" > 
                        </label> 
                        <label v-else-if="submitError && !$v.title.minLength" 
                            class="lblError" >
                            O campo deve ter mais que 5 caracteres
                        </label> 
                      </transition> 
                    </div>
                  </div>

                  <!-- Description -->
                  <div class="row">
                    <div class="col">
                      <div class="form-group">
                        <label class="text-muted">{{$ml.get('description')}}</label >
                        <svg v-show="!htmlText" @click="viewHtml()" width="24" height="24" class="ico-view-report">
                          <image xlink:href="../../assets/icons/eye.svg" width="24" height="24" />
                        </svg>
                        <svg v-show="htmlText" @click="htmlText = ''" width="24" height="24" class="ico-view-report">
                          <image xlink:href="../../assets/icons/eye-slash.svg" width="24" height="24" />
                        </svg>
                        <textarea v-show="!htmlText" id="" class="form-control w-100 text-are-mark" rows="7"
                          v-model="description"
                          :placeholder="'Adicione os detalhes da vaga...'">
                        </textarea>
                          
                        <div v-show="htmlText" class="form-control w-100 h-100" v-html="htmlText">
                        </div> 
                      </div>
                      <transition name="fade"> 
                        <label v-if="submitError && !$v.description.required" 
                          class="lblError" v-text="$ml.get('requiredField')"></label>
                        <label v-else-if="submitError && (!$v.description.minLength || !$v.description.maxLength)" 
                          class="lblError" v-text="'A descrição deve ter entre 5 e 30000 caracteres'"></label>
                      </transition>  
                    </div>
                  </div>

                  <div class="col-24">

                    <!-- Modelo de trabalho -->
                    <div class="row">
                      <div class="col-12 pr-3">
                        <div class="form-group">
                          <label class="text-muted">{{$ml.get('workModel')}}</label>
                          <multiselect 
                            v-model="work_model" 
                            label="" 
                            :options="itensWork_model"
                            :custom-label="nameLang"
                            :close-on-select="true" 
                            :show-labels="false"  
                            :multiple="false"
                            :allow-empty="false" 
                            :preselect-first="true">
                          </multiselect>
                        </div>
                      </div> 

                    <!-- Contract Type --> 
                      <div class="col-12">
                        <div class="form-group">
                          <label class="text-muted">{{$ml.get('typeOfContract')}}</label>
                          <multiselect 
                            v-model="contract_type" 
                            label="" 
                            :options="itensContract_type"
                            :custom-label="nameLang"
                            :close-on-select="true" 
                            :show-labels="false"  
                            :multiple="false"
                            :allow-empty="false" 
                            :preselect-first="true">
                          </multiselect>
                        </div>
                      </div>
                    </div>

                    <!-- Work schedule -->
                    <div class="row">
                      <div class="col-8">
                        <div class="form-group">
                          <label class="text-muted">{{$ml.get('workSchedule')}}</label>
                          <multiselect 
                            v-model="work_schedule" 
                            label="" 
                            :options="itensWork_schedule"
                            :custom-label="nameLang"
                            :close-on-select="true" 
                            :show-labels="false"  
                            :multiple="false"
                            :allow-empty="false" 
                            :preselect-first="true">
                          </multiselect>
                        </div> 
                      </div> 

                    <!-- State --> 
                      <div class="col-6 pl-3">
                        <div class="form-group">
                          <label class="text-muted">{{$ml.get('stateCity')}}</label>
                          <multiselect 
                            v-model="state" 
                            label="text" 
                            :options="states"
                            :close-on-select="true" 
                            :show-labels="false"  
                            :multiple="false"
                            :allow-empty="false" 
                            :preselect-first="true">
                          </multiselect>
                        </div>
                        <transition name="fade">  
                          <label v-if="stateError " 
                            class="lblError" v-text="$ml.get('select')">
                          </label>
                        </transition> 
                      </div> 

                    <!-- City --> 
                      <div class="col-10 pl-3">
                        <div class="form-group">
                          <label class="text-muted">{{$ml.get('city')}}</label>
                          <multiselect 
                            v-model="city" 
                            label="" 
                            :options="citys"
                            :close-on-select="true" 
                            :show-labels="false"  
                            :multiple="false"
                            :allow-empty="false" 
                            :preselect-first="true">
                          </multiselect>
                        </div>
                        <transition name="fade">  
                          <label v-if="cityError " 
                            class="lblError">
                            {{$ml.get('select')}}
                          </label>
                        </transition> 
                      </div>
                    </div>
      
                    <!-- Link -->
                    <div class="row mb-2">
                      <div class="col-12 ">
                        <div class="form-group">
                          <label class="text-muted">{{$ml.get('linkToJob')}}</label>
                          <input
                            type="text"
                            v-model="url"
                            class="form-control"
                            placeholder="www.seusite.com/vagas"
                            maxlength="40"
                          />
                        </div>
                        <transition name="fade"> 
                          <label v-if="submitError && !$v.url.required"
                              class="lblError" 
                              v-text="$ml.get('requiredField')" > 
                          </label> 
                          <label v-else-if="submitError && !$v.url.regexURL" 
                              class="lblError" >
                              {{$ml.with("Link").get("theIsNotValid")}}
                          </label> 
                        </transition> 
                      </div>
                    </div>
    
                    <div class="row">
                      <button class="btn m-0 px-4" @click="saveJobs()">
                        <Spinner v-show="loadingBtn" />
                        <span v-show="!loadingBtn">{{$ml.get('save')}}</span >
                      </button>
                    </div>

                  </div>
 
              </form>
            </div>  
          </div>
  
        </div>
      </div>
      <!-- Modal link -->
      <b-modal
        id="modal-link-job"
        class="my-modal"
        data-bs-keyboard="false"
        hide-header
        size="ml"
        footer-bg-variant="light"
        @hidden="resetLink"
      >
        <b-container fluid="lg">
          <div class="col modal-body">
            <h4 class=" m-0">{{$ml.get('externalLinkNotice')}}</h4>
          </div>
        </b-container>

        <form class="h-100">
          <div class="col p-3 ">  
            <p > {{$ml.get('youAreAboutToVisitLink')}} </p > 
            <p class="my-0" > {{$ml.get('youShouldConsiderUsingSeparate')}} </p > 
          </div>  
          <pre class="mx-3 py-0 d-flex justify-content-start"> 
            <code class="p-2" > {{linkTarget}}</code>
          </pre> 
        </form>

        <template #modal-footer> 
          <div class="w-100 float px-3">  
            <b-button variant="primary" size="sm" class="float-right btn-outline-extra" 
              v-text="$ml.get('cancel')" 
              @click="$bvModal.hide('modal-link-job')" >
            </b-button>
            <a class="float-right mr-3" target="_blank" rel="noopener noreferrer" :href="linkTarget" 
              @click="$bvModal.hide('modal-link-job')"> 
              <b-button variant="primary" size="sm" v-text="$ml.get('continue')"> </b-button> 
            </a> 
          </div>
        </template>
      </b-modal> 
    </section> 
  </main>
</div>
</template>

<script> 
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import CompanyService from "../../services/company.service"; 
import brasil from "../../assets/json/brasil.json";
import Swal from "sweetalert2";
import { utils } from "../../utils";

const regexURL = utils.regexCheck("URL");
 
export default {
  components: { 
 
  },
  data() {
    return {

      menuItem: "jobs",

      citys: ["Selecione"],
      
      city: "",
      state: { value: null, text: "Selecione" },
      
      brasil,
      states: [
        { value: null, text: "Selecione" },
        { value: "AC", text: "Acre" },
        { value: "AL", text: "Alagoas" },
        { value: "AP", text: "Amapá" },
        { value: "AM", text: "Amazonas" },
        { value: "BA", text: "Bahia" },
        { value: "CE", text: "Ceará" },
        { value: "DF", text: "Distrito Federal" },
        { value: "ES", text: "Espírito Santo" },
        { value: "GO", text: "Goiás" },
        { value: "MA", text: "Maranhão" },
        { value: "MT", text: "Mato Grosso" },
        { value: "MS", text: "Mato Grosso do Sul" },
        { value: "MG", text: "Minas Gerais" },
        { value: "PA", text: "Pará" },
        { value: "PB", text: "Paraíba" },
        { value: "PR", text: "Paraná" },
        { value: "PE", text: "Pernambuco" },
        { value: "PI", text: "Piauí" },
        { value: "RJ", text: "Rio de Janeiro" },
        { value: "RN", text: "Rio Grande do Norte" },
        { value: "RS", text: "Rio Grande do Sul" },
        { value: "RO", text: "Rondônia" },
        { value: "RR", text: "Roraima" },
        { value: "SC", text: "Santa Catarina" },
        { value: "SP", text: "São Paulo" },
        { value: "SE", text: "Sergipe" },
        { value: "TO", text: "Tocantins" }
      ],


      htmlText: false,

      pageActive: 1,
      pageSize: 10,
      totalPages: 0,

      title: "", 
      description: this.$ml.get("jobDescription"),

      work_model: "",
      itensWork_model: [ "remote", "hybrid", "office"],

      contract_type: "",
      itensContract_type: [ "clt", "pj", "autonomous", "clt-flex", "cooperative", "internship"],
      
      work_schedule: "",
      itensWork_schedule: ["full-time", "part-time", "others" ],
  
      
      url: "",
      linkTarget: "",

      loadingBtn: false,
      loadingJobs: false,
      submitError: false,
      stateError: false,
      cityError: false,

      listJobs:[], 

      titleSearch: "",
      locationSearch: "",
 
      checkWork_model: "",
      checkWork_schedule: "",
      checkContract_type: "",
        
      arrayContract_type: [],
      arrayWork_model: [],
      arrayWork_schedule: [], 
      showOriginalDescription: false,
 
    };
  },
  validations: {
    title: { required, minLength: minLength(5) },
    description: { required, minLength: minLength(5), maxLength: maxLength(30000) },
 
    url: { required, regexURL },
 
  },
  mounted(){
    this.changeFilter();  
    this.changeJobs();  
    this.$v.$reset();
  },

  watch: {
    'state': function () {
      this.citys = brasil[this.state.value].cidades; 
    },

    titleSearch: function () {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(async () => { 
        this.changeJobs() 
      }, 1000); 
    },

    locationSearch: function () {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(async () => { 
        this.changeJobs() 
      }, 1000); 
    },

    pageActive: function () {
      this.changeJobs();
    },

    checkContract_type: function () {
      this.changeJobs()  
    },

    checkWork_schedule: function () {
      this.changeJobs()  
    },

    checkWork_model: function () {
      this.changeJobs()  
    }

  },
 
  methods: {
    resetLink(){
      this.linkTarget = '';
    },

    linkExternal(e){
      var self = this;
      const element = e.target;
      if (element.tagName == "A" && element.getAttribute('class') && element.getAttribute('class').includes('link-download')){
        return;
      }
      if (element.tagName == "A" && element.getAttribute('href')) {
        e.preventDefault();
        self.linkTarget = element.getAttribute('href');
        self.$bvModal.show("modal-link-job");
      }
    },

    nameLang( name ) {
      return `${this.$ml.get(name.replace('-',''))}`;
    },
    
    viewHtml() {
      this.htmlText = "";
      this.htmlText = this.$utils.convertMarkedOld(
        this.description);
    },

    changeFilter() {

      this.arrayContract_type = [];
      this.arrayWork_model = [];
      this.arrayWork_schedule = [];
  
      CompanyService.getJobListFilters()
      .then(
        (response) => {
 
          this.arrayContract_type = response.data.contract_type;
          this.arrayWork_model = response.data.work_model;
          this.arrayWork_schedule = response.data.work_schedule;
  
        }).catch( () => {
        Swal.fire({
          icon: "info",
          title: this.$ml.get("unableToCompleteThisRequest"), 
          showConfirmButton: false,
          timer: 3000,
        }); 
        this.loadingJobs = false;
      });
    },

    changeJobs() {
      this.loadingJobs = true;
      this.listJobs = []; 

      let payload = []
 
      payload.page = this.pageActive;
      payload.pageSize = this.pageSize;

      if(this.titleSearch){
        payload.title = this.titleSearch
      }

      if(this.locationSearch){
        payload.location = this.locationSearch
      }

      if(this.checkContract_type){
        payload.contract_type = this.checkContract_type
      }
      
      if(this.checkWork_schedule){
        payload.work_schedule = this.checkWork_schedule
      }
      
      if(this.checkWork_model){
        payload.work_model = this.checkWork_model
      }

      CompanyService.getJobAdvertisement(payload)
      .then(
        (response) => {
          this.loadingJobs = false; 
          this.listJobs = response.data.items;  
          this.totalPages = response.data.total;
       
        }).catch( () => {
        Swal.fire({
          icon: "info",
          title: this.$ml.get("unableToCompleteThisRequest"), 
          showConfirmButton: false,
          timer: 3000,
        }); 
        this.loadingJobs = false;
      });
    },
   
    saveJobs() { 
      this.$v.$touch();
      this.submitError = false;
      this.stateError = false;
      this.cityError = false;
      if ( this.$v.$invalid ) {
        this.submitError = true;
        return;
      }

      if(this.work_model != 'remote'){

        if(this.state.text == 'Selecione'){
          this.stateError = true
          return
        }
        if(this.city == 'Selecione'){
          this.cityError = true
          return
        }
        
      }
  
      this.loadingBtn = true;

      let payload = {
          "title": this.title,
          "description": this.description,
          "work_model": this.work_model,
          "contract_type": this.contract_type,
          "work_schedule": this.work_schedule,
          "url": this.url,
          "city": this.city == 'Selecione' ?  '' : this.city,
          "state": this.state.text == 'Selecione' ? '' : this.state.text
      }

      CompanyService.postJobAdvertisement(payload)
      .then( () => {
        this.loadingBtn = false;
        this.title = "";
        this.url = "";
        this.city = "",
        this.state = { value: null, text: "Selecione" };
        this.changeJobs();
        Swal.fire({
          icon: "success",
          title: this.$ml.get("registrationDone"),
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
        
      }).catch( () => {
        Swal.fire({
          icon: "info",
          title: this.$ml.get("unableToCompleteThisRequest"), 
          showConfirmButton: false,
          timer: 3000,
        }); 
        this.loadingBtn = false;
      });
    },
   
    removeJobs(item) {
      var self = this;

      Swal.fire({
        icon: "info",
        title: this.$ml.get("doyoureallyWanttoDeleteVacancy"),
        showCancelButton: true,
        showConfirmButton: true, 
        cancelButtonText: this.$ml.get("cancel"),
        confirmButtonText: this.$ml.get("continue"), 
        confirmButtonColor: "#3085d6",
        customClass: {
          cancelButton: 'btn-outline-extra',
        },
      })
      .then((result) => {
        if (result.isConfirmed) {
          CompanyService.putJobAdvertisement(item._id)
          .then( ( ) => { 
            self.changeJobs(); 
            Swal.fire({
              icon: "info",
              title: this.$ml.get("removed"), 
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            });
          }).catch( () => {
            Swal.fire({
              icon: "info",
              title: this.$ml.get("unableToCompleteThisRequest"), 
              showConfirmButton: false,
              timer: 3000,
            }); 
          }); 
        }  
      })  
    },
 

  },
};
</script>
<style scoped>
  .active {
  color: #E10E71 !important; 
  }
  .active > a { 
    font-weight: 500;
  }
  .lblError {
    position: relative;
    top: -18px !important; 
    margin: 0px !important;  
  }
  .ico-view-report {
    margin-top: 33px !important;
  }
  .angle-right {
    -ms-transform: rotate(90deg); /* IE 9 */
    transform: rotate(90deg);
  }

  .collapsed > .when-opened,
  :not(.collapsed) > .when-closed {
    display: none;
  }

  .label-check {
    margin-top: -3px;
  }

  /*Custom checkboxes style*/
.custom-checkbox input[type="checkbox"] + .label-text:before {
  content: "";
  text-transform: none;
  line-height: 0.8;
  display: inline-block;
  border-radius: 3px;
  border: #730ca8 1px solid;
  padding: 7px;
  position: absolute;
 
}
.custom-checkbox input[type="checkbox"]:checked + .label-text:before {
  content: "✓";
  color: #730ca8;
  border: #730ca8 1px solid;
  animation: effect 250ms ease-in;
  padding: 1px;
}
@keyframes effect {
 
  25% {
    transform: scale(1.3);
  }
 
  100% {
    transform: scale(1);
  }
}
.icon-description{
  cursor: pointer;
  position: absolute;
  top: 6px;
  right: 0px;
}
</style>
 